"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAppName = exports.AppName = void 0;
/**
 * E-Chain application names used for the appName environment property.
 */
var AppName;
(function (AppName) {
    AppName["EIQ"] = "EIQ";
    AppName["EKE"] = "EKE";
    AppName["EIC"] = "EIC";
    AppName["ECF"] = "ECF";
    /**
     * The test name should only be used in test scenarios.
     */
    AppName["TEST"] = "TEST";
})(AppName = exports.AppName || (exports.AppName = {}));
const isAppName = (possibleAppName) => {
    if (!possibleAppName)
        return false;
    return [AppName.EIQ, AppName.EKE, AppName.EIC, AppName.ECF, AppName.TEST].includes(possibleAppName);
};
exports.isAppName = isAppName;
//# sourceMappingURL=AppName.js.map